import React, { useEffect, useState } from 'react'
import { useFloatingOverlay } from 'components/atoms/floatingStack'
import styled from 'styled-components'
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom'
import { PATHS, PRIVATE_PATHS, setNavigate } from 'utils/paths'
import Login from 'features/auth/Login'
import SignUp from 'features/auth/SignUp'
import TwoFactorSetup from 'features/auth/TwoFactorSetup'
import Dashboard from 'features/dashboard/Dashboard'
import TopBar from 'features/navigation/TopBar'
import OfflineBanner from 'components/OfflineBanner'
import AiProviderBanner from 'components/AiProviderBanner'
import Navigation from 'features/navigation/Navigation'
import BottomBar from 'features/navigation/BottomBar'
import EmailConfirmation from 'features/auth/EmailConfirmation'
import HomePage from 'features/homePage/HomePage'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  fetchAuthUserRoutine,
  logoutUserRoutine
} from 'features/auth/ducks/actions'
import {
  getCurrentUserRole,
  isUserLoggedIn,
  getCurrentUser
} from 'features/auth/ducks/selectors'
import PrivateRoute from 'components/PrivateRoute'
import RequestResetPassword from 'features/auth/RequestResetPassword'
import PasswordReset from 'features/auth/PasswordReset'
import ShortlistedBps from 'features/shortlistedBps/ShortlistedBps'
import BpDetails from 'features/bpDetails/BpDetails'
import ProfileSettings from 'features/profileSettings/ProfileSettings'
import Cart from 'features/cart/Cart'
import NotFound, { RedirectToNotFound } from 'components/NotFound'
import CreateBp from 'features/createBp/CreateBp'
import Drafts from 'features/drafts/Drafts'
import PaymentSuccess from 'features/cart/components/PaymentSuccess'
import BillingList from 'features/billingList/BillingList'
import PastDueSubscriptionAlert from 'features/billingList/PastDueSubscriptionAlert'
import SubscriptionExpiryBanner from 'features/billingList/SubscriptionExpiryBanner'
import Terms from 'features/terms/terms'
import AccessRequest from 'features/AccessRequest/AccessRequest'
import storageService from 'services/LocalStorageService'
import { KEYS } from 'utils/localStorage'
import packageJson from '../package.json'
import GlobalLoader from 'components/GlobalLoader'
import GuruLauncher from 'features/guru/GuruLauncher'
import LoadTimeWidget from 'components/LoadTimeWidget'
import GuruWidget from 'features/guru/GuruWidget'
import GuruPeek from 'features/guru/GuruPeek'
import { selectGlobalLoader } from 'ducks/loaderSelectors'
import { selectIsOnline } from 'ducks/offline/selectors'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'
import Analytics from 'features/analytics/Analytics'
import AddTemplate from 'features/analytics/AddTemplate'
import EditTemplates from 'features/analytics/EditTemplates'
import SignUpConfirmation from 'features/auth/components/SignUpConfirmation'
import { pdfjs } from 'react-pdf'
import { pathOr, propOr } from 'ramda'
import UpdateInfoExchangeAccount from 'features/auth/UpdateInfoExchangeAccount'
import { isNotNilOrEmpty } from 'utils/ramda'
import { getFileTypesRoutine } from 'ducks/files/actions'
import {
  getFileCategoriesRoutine,
  getFoldersRoutine
} from 'ducks/dictionaries/actions'
import { clearLargeCookies } from 'utils/clearLargeCookies'
import deferIdle from 'utils/deferIdle'
import { getBuildingTypesRoutine } from 'features/bpList/ducks/actions'
import LoginCallback from 'features/auth/LoginCallback'
import { useLocation } from 'react-router'
import AddMultipleFilesPage from './features/bpDetails/Components/files/AddMultipleFilesPage'
import SessionExpiryModal from './features/session/SessionExpiryModal'
import { initSessionListenerRoutine } from './features/session/ducks/actions'
import ExternalAccessSharedFilesPage from 'features/bpDetails/Components/files/ExternalAccessSharedFilesPage'
import SharePointCallback from 'features/bpDetails/Components/SharePoint/SharePointCallback'
import ExternalLayout from 'layouts/ExternalLayout'
import InsuranceGuruPublicReportPage from 'pages/InsuranceGuruPublicReportPage'
import ReportEvidencePage from 'pages/ReportEvidencePage'
import AbandonedCartPage from 'pages/AbandonedCartPage'
import ExternalTaskPage from 'features/taskManagement/ExternalTaskPage'
import 'assets/toastify-custom.css'
import { TutorialProvider } from 'features/tutorials/context/TutorialContext'
import MiniTutorialPlayer from 'features/tutorials/MiniTutorialPlayer'
import TutorialDetail from "./features/tutorials/TutorialDetail"
import WhatsNewModal from 'features/whatsNew/WhatsNewModal'
import { getWhatsNewStatusRoutine } from 'features/whatsNew/ducks/actions'
import { selectWhatsNewStatus } from 'features/whatsNew/ducks/selectors'
import TutorialsPanel from 'features/tutorials/TutorialsPanel'
import { TourProvider as SpotlightTourProvider } from 'features/tours/TourContext'
import { WorkflowProvider } from 'features/tours/WorkflowProvider'
import WhatsNewPanel from "./features/whatsNew/WhatsNewPanel";
import TaskManagement from 'features/taskManagement/TaskManagement';
import ComplianceGuard from 'features/compliance/ComplianceGuard';
import TaskManagementGuard from 'features/compliance/TaskManagementGuard';
import ProgrammePage from 'features/compliance/ProgrammePage';
import LegislationPage from 'features/compliance/legislation/LegislationPage';
import RemedialsSection from 'features/compliance/RemedialsSection';
import ObligationSetupPage from 'features/compliance/ObligationSetupPage';
import AssetRegisterPage from 'features/assets/AssetRegisterPage';
import PortfolioReport from 'features/dashboard/sections/PortfolioReport';
import TaskHub from 'features/taskManagement/TaskHub';
import RemedialsReviewPage from 'features/taskManagement/RemedialsReviewPage';
import CreateTask from 'features/taskManagement/CreateTask';
import TaskDomainsManager from 'features/taskManagement/components/TaskDomainsManager';
import TaskDetail from 'features/taskManagement/TaskDetail';
import TaskSeriesRedirect from 'features/taskManagement/TaskSeriesRedirect';
import ObligationTaskRedirect from 'features/taskManagement/ObligationTaskRedirect';
import TaskCalendar from 'features/taskManagement/TaskCalendar';
import CalendarSubscriptionPage from 'features/taskManagement/CalendarSubscriptionPage';
import PortfolioDetail from 'features/portfolio/PortfolioDetail';
import PortfoliosArea from 'features/portfolios/PortfoliosArea';
import EstateDetailPage from 'features/bpList/Components/estates/EstateDetailPage';
import FormTemplates from 'features/taskManagement/FormTemplates';
import { FormGenerationProvider } from 'features/taskManagement/components/GenerateFormFromDocument/FormGenerationContext';
import NotificationPreferences from 'features/notifications/NotificationPreferences';
import IncidentsPage from 'features/incidents/IncidentsPage';
import GuruSharePage from 'features/guruShare/GuruSharePage';
import GuruSourceLandingPage from 'features/guruShare/GuruSourceLandingPage';
import GuruPublicSharePage from 'features/guruShare/GuruPublicSharePage';
import GuruPage from 'features/guru/GuruPage';
import UnitQrLanding from 'features/qrLanding/UnitQrLanding'
import BuildingQrLanding from 'features/qrLanding/BuildingQrLanding'
import IncidentDetail from 'features/incidents/components/IncidentDetail';
import ActionDetail from 'features/actions/components/ActionDetail';
import DocumentAccessRequestsPage from 'features/documentAccess/DocumentAccessRequestsPage';
import OrganisationPage from 'features/organisation/OrganisationPage';
import ContractManagementTool from 'features/contracts/ContractManagementTool';
import PermitsPage from 'features/permits/PermitsPage';
import PermitPrintView from 'features/permits/PermitPrintView';
import ExitReadinessPage from 'features/handover/ExitReadinessPage';
import KpiReportPage from 'features/dashboard/sections/KpiReportPage';
import BuildingsAtRiskPage from 'features/dashboard/sections/BuildingsAtRiskPage';
import PwaInstallPrompt from 'components/PwaInstallPrompt'
import usePushNotificationsBridge from 'features/notifications/hooks/usePushNotificationsBridge'
import HelpHost from 'features/help/HelpHost'

const GlobalWhatsNew = () => {
  const dispatch = useDispatch()
  const status = useSelector(selectWhatsNewStatus)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!checkIsOnline()) return

    const fetchList = async () => {
      try {
        const res = await fetch('/api/whatsnew', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('api-token')}`,
          },
        })
        if (!res.ok) return
        const contentType = res.headers.get('content-type') || ''
        if (!contentType.includes('application/json')) return
        const data = await res.json()

        // Save the list for Navigation badge
        localStorage.setItem('whatsnew_cache', JSON.stringify(data))
        window.dispatchEvent(new Event('storage'))
      } catch {
        // Silently ignore — whatsnew is non-critical
      }
    }

    deferIdle(() => {
      dispatch(getWhatsNewStatusRoutine.trigger())
      fetchList()
    })
  }, [dispatch])

  useEffect(() => {
    const host = window.location.hostname
    const isLocal =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host.endsWith('.local') ||
      process.env.NODE_ENV === 'development'

    if (isLocal) {
      setShow(true)
      return
    }

    if (status.shouldPopup) {
      setShow(true)
    }
  }, [status])

  if (!show) return null

  return <WhatsNewModal onClose={() => setShow(false)} />
}

const OfflineGuard = ({ children }) => {
  const isOnline = useSelector(selectIsOnline)
  if (!isOnline) {
    !window.location.pathname.startsWith('/tasks') && window.location.replace('/tasks')
    return null
  }
  return children
}

const TAB_TO_LEVEL = { estate: 'estate', unit: 'unit', bp: 'bp' }

const BpListRedirect = () => {
  const location = useLocation()
  const tab = new URLSearchParams(location.search).get('tab')
  const level = TAB_TO_LEVEL[tab]
  const target = level ? `${PRIVATE_PATHS.portfolios}?level=${level}` : PRIVATE_PATHS.portfolios
  return <Navigate to={target} replace />
}

function App({ userRole, isloggedin }) {
  const dispatch = useDispatch()
  const [versionChecked, setVersionChecked] = useState(false)
  const isLoading = useSelector(selectGlobalLoader)
  const [dictionariesFetched, setDictionariesFetched] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const currentPath = location.pathname
  const isExternalAccess = currentPath.startsWith('/external-access')
  const isExternalTask = currentPath.startsWith('/external-tasks')
  const isInsuranceGuruPublic = currentPath.startsWith('/insurance-guru/report/')
  const isReportEvidence = currentPath.startsWith('/report-evidence/')
  const isGuruPublicShare = currentPath.startsWith('/share/guru/')
  // QR landing pages are public but rendered chrome-free (sticker scans
  // are mobile, the app's nav/topbar would just get in the way). Auth is
  // still fetched so signed-in scanners can be redirected to the real
  // unit/BP page rather than re-shown the sign-in prompt.
  const isQrLanding = /^\/u\/[^/]+$/.test(currentPath) || /^\/b\/[^/]+\/request-access$/.test(currentPath)
  const isTwoFactorSetupPage = currentPath === PRIVATE_PATHS.twoFactorSetup
  const [authFetched, setAuthFetched] = useState(false)
  const isFileUploadPage = currentPath.includes('/files/upload/')
  const [tutorialsPanelOpen, setTutorialsPanelOpen] = useState(false)
  const [whatsNewPanelOpen, setWhatsNewPanelOpen] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  // Keeps the floating controls (Guru launcher, compliance pill, dev widget)
  // from covering the mobile navigation sheet while it is open.
  useFloatingOverlay('mobile-nav', mobileMenuOpen)
  // Web Push: re-attach subscription after login, react to SW push messages.
  usePushNotificationsBridge(isloggedin)

  useEffect(() => {
    setNavigate(navigate)
  }, [navigate])

  useEffect(() => {
    if (!currentPath?.includes('callback') && !authFetched && !isExternalAccess && !isExternalTask && !isInsuranceGuruPublic && !isReportEvidence && !isGuruPublicShare) {
      dispatch(fetchAuthUserRoutine())
      setAuthFetched(true)
    }

    // Clear large cookies to prevent 431 errors (one-time migration to localStorage)
    clearLargeCookies()

    const appVersion = storageService.get(KEYS.version) || ''
    const packageJsonVersion = packageJson.version
    if (appVersion !== packageJsonVersion) {
      storageService.set(KEYS.version, packageJsonVersion)
      dispatch(
        logoutUserRoutine({
          callback: () => window.location.reload(true)
        })
      )
    } else if (!versionChecked) {
      setVersionChecked(true)
    }

    pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs'
  }, [currentPath, authFetched, versionChecked])

  useEffect(() => {
    if (isloggedin && !dictionariesFetched) {
      if (checkIsOnline()) {
        dispatch(initSessionListenerRoutine())
        deferIdle(() => {
          dispatch(getFileTypesRoutine())
          dispatch(getFileCategoriesRoutine())
          dispatch(getFoldersRoutine())
          dispatch(getBuildingTypesRoutine())
        })
      }
      setDictionariesFetched(true)
    } else if (!isloggedin && dictionariesFetched) {
      setDictionariesFetched(false)
    }
  }, [isloggedin, dictionariesFetched])

  useEffect(() => {
    const handleOpenPanel = () => {
      setTutorialsPanelOpen(true)
    }
    window.addEventListener('openTutorialsPanel', handleOpenPanel)
    return () => window.removeEventListener('openTutorialsPanel', handleOpenPanel)
  }, [])

  useEffect(() => {
    const handleOpen = () => setWhatsNewPanelOpen(true)
    window.addEventListener('openWhatsNewPanel', handleOpen)
    return () => window.removeEventListener('openWhatsNewPanel', handleOpen)
  }, [])


  const currentUser = useSelector(getCurrentUser)
  const currentUserSource = pathOr('', ['source', 'value'], currentUser)
  const isFromInfoExchange = currentUserSource === 'info_exchange'
  const hasCurrentUserFirstName = isNotNilOrEmpty(
    propOr('', 'firstName', currentUser)
  )

  if (isExternalAccess) {
    return (
      <ExternalLayout>
        <Routes>
          <Route
            path="/external-access/:fileShareId"
            element={<ExternalAccessSharedFilesPage />}
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </ExternalLayout>
    )
  }

  if (isExternalTask) {
    return (
      <ExternalLayout>
        <Routes>
          <Route
            path="/external-tasks/:shareToken"
            element={<ExternalTaskPage />}
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </ExternalLayout>
    )
  }

  if (isInsuranceGuruPublic) {
    return (
      <ExternalLayout>
        <Routes>
          <Route
            path="/insurance-guru/report/:token"
            element={<InsuranceGuruPublicReportPage />}
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </ExternalLayout>
    )
  }

  if (isReportEvidence) {
    return (
      <ExternalLayout>
        <Routes>
          <Route
            path="/report-evidence/:token"
            element={<ReportEvidencePage />}
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </ExternalLayout>
    )
  }

  if (isGuruPublicShare) {
    return (
      <ExternalLayout>
        <Routes>
          <Route
            path={PATHS.guruPublicShare}
            element={<GuruPublicSharePage />}
          />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </ExternalLayout>
    )
  }

  return (
    <FormGenerationProvider>
    <AppContainer>
      {isLoading && <GlobalLoader />}
      {!versionChecked && <LoadingScreen />}
      {!isFileUploadPage && !isExternalAccess && !isTwoFactorSetupPage && !isQrLanding && <OfflineBanner />}
      {!isExternalAccess && !isTwoFactorSetupPage && !isQrLanding && <AiProviderBanner isLoggedIn={isloggedin} />}
      {!isFileUploadPage && !isExternalAccess && !isTwoFactorSetupPage && !isQrLanding && (
        <TopBar
          isloggedin={isloggedin}
          onOpenMobileMenu={() => setMobileMenuOpen(true)}
        />
      )}
      {isloggedin && !isFileUploadPage && !isExternalAccess && !isTwoFactorSetupPage && !isQrLanding && (
        <Navigation
          mobileOpen={mobileMenuOpen}
          setMobileOpen={setMobileMenuOpen}
        />
      )}
      {isloggedin && currentUser && !isTwoFactorSetupPage && <SessionExpiryModal />}
      <PastDueSubscriptionAlert enabled={isloggedin && userRole === 'user'} />
      <Content
        $isloggedin={isloggedin && !isTwoFactorSetupPage}
        $isFileUploadPage={isFileUploadPage}
        $isTwoFactorSetupPage={isTwoFactorSetupPage}
      >
        {isFromInfoExchange && !hasCurrentUserFirstName && (
          <FakeModal>
            <UpdateInfoExchangeAccount userInfo={currentUser} />
          </FakeModal>
        )}
        <SubscriptionExpiryBanner
          enabled={isloggedin && userRole === 'user' && !isFileUploadPage && !isExternalAccess && !isTwoFactorSetupPage && !isQrLanding}
        />
        <Routes>
          <Route path={PATHS.home} element={<HomePage />} />
          <Route path={PATHS.login} element={<Login />} />
          <Route path={PATHS.loginCallback} element={<LoginCallback />} />
          <Route path={PATHS.signup} element={<SignUp />} />
          <Route path={PATHS.signupConfirm} element={<SignUpConfirmation />} />
          <Route
            path={PATHS.emailVerification}
            element={<EmailConfirmation />}
          />
          <Route
            path={PATHS.requestPasswordReset}
            element={<RequestResetPassword />}
          />
          <Route path={PATHS.passwordReset} element={<PasswordReset />} />
          <Route path={PATHS.sharepointCallback} element={<SharePointCallback />} />
          <Route path={PATHS.unitQrLanding} element={<UnitQrLanding />} />
          <Route path={PATHS.buildingQrLanding} element={<BuildingQrLanding />} />
          <Route path={PATHS.abandonedCart} element={<AbandonedCartPage />} />
          <Route
            path={PRIVATE_PATHS.twoFactorSetup}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user', 'emergency_service', 'responsible_person']}>
                <TwoFactorSetup />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.dashboard}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Dashboard /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.bpList}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><BpListRedirect /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.drafts}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Drafts /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.savedPassports}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><ShortlistedBps /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.accessRequests}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><AccessRequest /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.savedDetails}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><BpDetails /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.guruShare}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><GuruSharePage /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.portfolioGuruShare}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><GuruSharePage /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.guruSource}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><GuruSourceLandingPage /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.guru}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><GuruPage /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.bpDetails}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><BpDetails /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.draftDetails}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><BpDetails /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.createBp}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><CreateBp /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.fileUpload}
            element={<AddMultipleFilesPage />}
          />
          <Route
            path={PRIVATE_PATHS.profileSettings}
            element={
              <PrivateRoute
                userRole={userRole}
                allowedRoles={['user', 'emergency_service']}
              >
                <OfflineGuard><ProfileSettings /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.cart}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Cart /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.terms}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Terms /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.paymentSuccess}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><PaymentSuccess /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.billingList}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><BillingList /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.paymentError}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Cart /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.analytics}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><Analytics /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.addAnalytics}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><AddTemplate /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.editAnalytics}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><EditTemplates /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.createTask}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><CreateTask /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.calendar}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskCalendar />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.calendarSubscribe}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <CalendarSubscriptionPage />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.portfolios}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <PortfoliosArea />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.portfoliosAreaEstate}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <PortfoliosArea />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.portfolioDetail}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <PortfolioDetail />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.estateDetail}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <EstateDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.taskDomains}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><OfflineGuard><TaskDomainsManager /></OfflineGuard></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.taskSeries}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><OfflineGuard><TaskSeriesRedirect /></OfflineGuard></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.taskObligation}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><OfflineGuard><ObligationTaskRedirect /></OfflineGuard></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.taskDetails}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><TaskDetail /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.formBuilderEdit}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><OfflineGuard><FormTemplates /></OfflineGuard></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.formBuilder}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><OfflineGuard><FormTemplates /></OfflineGuard></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.taskManagement}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><TaskHub /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          {/* Deep-link aliases: keep the old /actions and /incidents URLs
              working but render the hub on the matching tab so links shared
              before the consolidation still land in the right place. The
              hub's own pathname-based tab detection handles the rest. */}
          <Route
            path={PRIVATE_PATHS.actions}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><TaskHub /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.actionsReview}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><RemedialsReviewPage /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.documentAccessRequests}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <DocumentAccessRequestsPage />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.organisation}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OrganisationPage />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.actionDetail}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><ActionDetail /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.incidents}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><TaskHub /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.contractManagement}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ContractManagementTool />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.contractors}
            element={<Navigate to={`${PRIVATE_PATHS.contractManagement}?tab=contractors`} replace />}
          />
          <Route
            path={PRIVATE_PATHS.incidentDetail}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <TaskManagementGuard><IncidentDetail /></TaskManagementGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.programme}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><ProgrammePage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.legislation}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><LegislationPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.remedials}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><RemedialsSection /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.remedialsReview}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><RemedialsReviewPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.obligationSetup}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><ObligationSetupPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.assetRegister}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><AssetRegisterPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.permits}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><PermitsPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.permitPrint}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <PermitPrintView />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.exitReadiness}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ExitReadinessPage />
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.portfolioReport}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><PortfolioReport /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.buildingsAtRisk}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><OfflineGuard><BuildingsAtRiskPage /></OfflineGuard></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.kpiReport}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <ComplianceGuard><KpiReportPage /></ComplianceGuard>
              </PrivateRoute>
            }
          />
          <Route
            path={PRIVATE_PATHS.notificationPreferences}
            element={
              <PrivateRoute userRole={userRole} allowedRoles={['user']}>
                <OfflineGuard><NotificationPreferences /></OfflineGuard>
              </PrivateRoute>
            }
          />
          <Route path={PATHS.notFound} element={<NotFound />} />
          <Route path="*" element={<RedirectToNotFound />} />
        </Routes>
      </Content>
      {isloggedin && !isFileUploadPage && !isExternalAccess && !isTwoFactorSetupPage && !isQrLanding && (
        <BottomBar isloggedin={isloggedin} />
      )}
      <ToastContainer style={{ top: 'env(safe-area-inset-top, 12px)' }} />
      {isloggedin && <LoadTimeWidget />}
      {isloggedin && !isTwoFactorSetupPage && (
        <>
          <GuruLauncher />
          <GuruWidget />
          <GuruPeek />
        </>
      )}
      {isloggedin && !isTwoFactorSetupPage && <GlobalWhatsNew />}
      {tutorialsPanelOpen && (
        <TutorialsPanel onClose={() => setTutorialsPanelOpen(false)} />
      )}
      {whatsNewPanelOpen && <WhatsNewPanel onClose={() => setWhatsNewPanelOpen(false)} />}
      <PwaInstallPrompt enabled={!isloggedin} />
    </AppContainer>
    </FormGenerationProvider>
  )
}

const mapStateToProps = state => ({
  isloggedin: isUserLoggedIn(state),
  userRole: getCurrentUserRole(state)
})

const ConnectedApp = connect(mapStateToProps)(App)

export default function AppWithTutorials() {
  return (
    <TutorialProvider>
      <SpotlightTourProvider>
        <WorkflowProvider>
          <ConnectedApp />
          <MiniTutorialPlayer />
          <HelpHost />
          <TutorialDetail />
        </WorkflowProvider>
      </SpotlightTourProvider>
    </TutorialProvider>
  )
}

const AppContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
`

const Content = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: ${({ $isloggedin, $isFileUploadPage, $isTwoFactorSetupPage }) =>
    $isTwoFactorSetupPage
      ? '0'
      : $isFileUploadPage
      ? '40px 50px'
      : $isloggedin
        ? '40px 50px 40px calc(var(--nav-rail-width, 106px) + 30px)'
        : '0 0'};
  background-color: rgb(247, 248, 253);
  height: ${({ $isFileUploadPage }) => ($isFileUploadPage ? '100vh' : 'auto')};
  min-height: ${({ $isFileUploadPage, $isTwoFactorSetupPage }) =>
    $isTwoFactorSetupPage || $isFileUploadPage ? '100vh' : 'calc(100vh - 88px)'};
  overflow-y: ${({ $isFileUploadPage }) => ($isFileUploadPage ? 'auto' : 'visible')};

  @media (max-width: 768px) {
    padding: ${({ $isFileUploadPage, $isloggedin, $isTwoFactorSetupPage }) =>
      $isTwoFactorSetupPage ? '0' : $isFileUploadPage ? '20px' : $isloggedin ? '70px 10px 90px 10px' : '20px 10px 90px 10px'};

    height: ${({ $isFileUploadPage }) => ($isFileUploadPage ? '100vh' : 'auto')};
    min-height: ${({ $isFileUploadPage, $isTwoFactorSetupPage }) =>
      $isTwoFactorSetupPage || $isFileUploadPage ? '100vh' : 'calc(100vh - 60px)'};
    overflow-y: ${({ $isFileUploadPage }) =>
      $isFileUploadPage ? 'auto' : 'visible'};
    background-color: transparent;
  }
`

const LoadingScreen = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.backgroundColor};
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`
const OfflineNotice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  font-size: 16px;
  color: #666;
  text-align: center;
  padding: 40px;

  a {
    margin-top: 12px;
    color: #33becc;
    font-weight: 600;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
`

const FakeModal = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`
